import { useState } from 'react'
import Sheet from './Sheet.jsx'
import { capture } from '../lib/notes.js'

/**
 * The pen. Alex's has a mic beside it; this one does not, on purpose — no
 * voice is what keeps this free.
 *
 * One rule carried over: no category picker here. Capture takes the thought
 * and nothing else. Filing happens later, from the Inbox.
 */
export default function CaptureButton({ onCaptured, toast, desktop = false }) {
  const [open, setOpen] = useState(false)
  const [body, setBody] = useState('')
  const [busy, setBusy] = useState(false)

  async function save(e) {
    e.preventDefault()
    if (busy || !body.trim()) return
    setBusy(true)
    try {
      await capture(body)
      setBody('')
      setOpen(false)
      toast('Captured')
      onCaptured?.()
    } catch (err) {
      toast(err.message || 'Could not save that.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button
        type="button"
        className={desktop ? 'toolbar-add' : 'capture'}
        aria-label="Capture a note"
        onClick={() => setOpen(true)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          {desktop ? <path d="M12 5v14M5 12h14" /> : <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z" />}
        </svg>
      </button>

      {open ? (
        <Sheet title="Capture" onClose={() => setOpen(false)}>
          <form onSubmit={save}>
            <div className="field">
              <textarea
                id="capture-body"
                rows={5}
                placeholder="Whatever it is. File it later."
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />
            </div>
            <button className="btn" type="submit" data-sheet-primary disabled={busy || !body.trim()}>
              {busy ? 'Saving…' : 'Capture'}
            </button>
          </form>
        </Sheet>
      ) : null}
    </>
  )
}
